import { Component } from '@angular/core';

@Component({
  selector: 'ngx-categories-widget',
  templateUrl: './categories-widget.component.html',
  styleUrls: ['./categories-widget.component.scss']
})
export class CategoriesWidgetComponent {
  constructor(){}
}
